export const WaveDivider = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 520 14' width='600' height='14'>
    <path
      d='M0 8 C 15 8, 15 4, 30 4 S 45 8, 60 8 S 75 4, 90 4 S 105 8, 120 8 S 135 4, 150 4 S 165 8, 180 8 S 195 4, 210 4 S 225 8, 240 8 S 255 4, 270 4 S 285 8, 300 8 S 315 4, 330 4 S 345 8, 360 8 S 375 4, 390 4 S 405 8, 420 8 S 435 4, 450 4 S 465 8, 480 8 S 495 4, 510 4 S 525 8, 540 8 S 555 4, 570 4 S 585 8, 600 8'
      stroke='currentColor'
      fill='none'
      strokeWidth='2'
    />
  </svg>
)
